import { useParams } from '@tanstack/react-router';
import { useCollectionUsage } from '@/services/db/collection/usage';
import { useWorkspaceIdFromCurrentUrl } from '@/services/router/use-workspace-id';
import { CollectionDetailPageShell } from './components/collection-detail-page-shell';
import { CollectionUsageTable } from './components/collection-usage-table';

function UsageBody() {
  const { collectionId } = useParams({ strict: false });
  const workspaceId = useWorkspaceIdFromCurrentUrl() ?? 0;
  const { data, isPending, isError, refetch } = useCollectionUsage({ id: collectionId ?? '' });

  return (
    <CollectionUsageTable
      campaigns={data ?? []}
      workspaceId={workspaceId}
      isLoading={isPending}
      hasError={isError}
      onRetry={() => void refetch()}
    />
  );
}

export default function UsagePage() {
  return (
    <CollectionDetailPageShell titleSuffix="usage">
      <UsageBody />
    </CollectionDetailPageShell>
  );
}
